import { useQuery } from "@tanstack/react-query";
import { tourMediaGalleryFactory } from "@/factories/pdp/pdp-header-about-factories";

export const fetchTourMediaGallery = (packageId: string) => async (): Promise<any> => {
  try {
    const url = `/api/pdp/tour-media-gallery?PackageNeoId=${packageId}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const rawTourMediaGallery = await response.json();
    console.log(rawTourMediaGallery, "rawTourMediaGallery");
    return tourMediaGalleryFactory(rawTourMediaGallery);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error sending GET request:", error); // TODO: log error to error tracking service
    throw error;
  }
};

const useTourMediaGallery = (
  packageId: string,
  packageDateId: string,
  neoId: string,
  contentfulData?: any,
  enabled: boolean = true
) => (
    useQuery({
      queryKey: ["PDP_TOUR_GALLERY", neoId, packageId, packageDateId],
      queryFn: fetchTourMediaGallery(packageId),
      enabled,
      staleTime: Infinity
    }));

export default useTourMediaGallery;
